import { getSessionStorageAsObject, getFromSessionStorage, mergeIntoSessionStorage } from 'automation-ui-core/storageUtils';

// Wootric documentation for reference:
// https://docs.wootric.com/javascript/#custom-properties

export let WootricCustomProp;
(function (WootricCustomProp) {
  WootricCustomProp["CreateFlowEntered"] = "workflows_create_flow_entered_date";
  WootricCustomProp["CreateButtonClicked"] = "workflows_create_button_clicked_date";
  WootricCustomProp["IndexPageViewed"] = "workflows_index_page_viewed_date";
  WootricCustomProp["CanvasPageViewed"] = "workflows_canvas_page_viewed_date";
  WootricCustomProp["ReviewPageViewed"] = "workflows_review_page_viewed_date";
  WootricCustomProp["WorkflowActivated"] = "workflows_activated_date";
})(WootricCustomProp || (WootricCustomProp = {}));
export const WOOTRIC_DATA_SESSION_KEY = 'WORKFLOWS_WOOTRIC_DATA';
export const TRIGGER_SETTING_PROP = WootricCustomProp.CreateFlowEntered;
export const isWootricSurveyTriggerSatisfied = () => !!getFromSessionStorage(WOOTRIC_DATA_SESSION_KEY)(TRIGGER_SETTING_PROP);
export const createCustomPropToSendOnTrigger = propName => {
  if (propName !== TRIGGER_SETTING_PROP && !isWootricSurveyTriggerSatisfied()) {
    return;
  }
  if (!getFromSessionStorage(WOOTRIC_DATA_SESSION_KEY)(propName)) {
    mergeIntoSessionStorage(WOOTRIC_DATA_SESSION_KEY)({
      [propName]: Math.floor(Date.now() / 1000)
    });
  }
};
export const getAllWootricCustomProps = () => getSessionStorageAsObject(WOOTRIC_DATA_SESSION_KEY);